const getColorByBgColor = (bgColor) => {
  return !bgColor
    ? "#000"
    : (parseInt(bgColor.replace("#", ""), 16) > 0xffffff / 2) ? "#000" : "#fff";
};

export default getColorByBgColor;
